/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import { translates } from '@/utils/translate';
import Scrollbar from '../scrollbar';
import { StyledRowResult } from './styled';
import RowInvoice from './row-invoice';

type Props<T> = {
  invoices: Record<string, string>;
  body: Array<T>;
  onEdit?: any;
  isLoading?: boolean;
};

export function TableInvoice<T extends Record<string, any>>({
  body,
  invoices,
  onEdit,
  isLoading,
}: Props<T>) {
  const [edit, setEdit] = useState('');
  if(!body || !body.length) return (<div />)
  const [{ fullId, ...FIRST_ELEMENT }] = body;
  const KEYS_HEAD = Object.keys(FIRST_ELEMENT);
  return (
    <TableContainer sx={{ overflow: 'unset' }}>
      <Scrollbar>
        <Table sx={{ minWidth: 960 }}>
          <TableHead
            sx={{
              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
              '& th': { backgroundColor: 'transparent' },
            }}
          >
            <TableRow>
              {KEYS_HEAD.map((key) => (
                <TableCell key={key}>{translates[key]}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            <>
              {body.length ? body.map((item, index) => {
                const { fullId, ...row } = item;
                return (
                  <RowInvoice
                    onEdit={onEdit}
                    row={row}
                    fullId={fullId}
                    head={KEYS_HEAD}
                    index={index}
                    key={index}
                    isLoading={isLoading}
                    editState={{ edit, setEdit }}
                  />
                );
              }): <div />}

              {Object.entries(invoices).map(([key, value]) => (
                <StyledRowResult key={key}>
                  <TableCell colSpan={KEYS_HEAD.length - 2} />

                  <TableCell align="right" sx={{ typography: 'body1' }}>
                    <Box sx={{ mt: 2 }} />
                    {translates[key]}
                  </TableCell>

                  <TableCell align="right" width={120} sx={{ typography: 'body1' }}>
                    <Box sx={{ mt: 2 }} />
                    {value}
                  </TableCell>
                </StyledRowResult>
              ))}
            </>
          </TableBody>
        </Table>
      </Scrollbar>
    </TableContainer>
  );
}
